export default __webpack_public_path__ + "static/6_32-092a3a4f4247b5ff276082fb939c9c6f.png";